import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

// Rotta della pagina di reset su questo front-end. Sta qui perche' e' il valore che finisce nel link
// della mail (il BE lo riceve come callback): cambiarla senza allineare app.routes.ts spedisce link morti.
export const RESET_PASSWORD_PATH = '/recupera-password';

@Injectable({ providedIn: 'root' })
export class PasswordResetService {

  constructor(private http: HttpClient) {}

  // Non passa da CtResetPasswordService: quello accoda al callback un suo path fisso
  // (/ct-authentication/reset-password) che su questo front-end non esiste, e il link della mail
  // finiva sul wildcard del router, cioe' in home. Il BE concatena "?t=&e=" a questo indirizzo.
  request(email: string): Observable<void> {
    return this.http.post<void>(`${environment.REST_API_SERVER}/ct/Login/ResetPassword`, {
      Email: email,
      CallBackUrlResetPassword: window.location.origin + RESET_PASSWORD_PATH,
    });
  }
}
